import api from './api';
import type { DadosPublicosParlamentar } from './transparenciaService';

export type MeuPerfilPublico = DadosPublicosParlamentar;

export type MeuPerfilPublicoEdicao = Omit<MeuPerfilPublico, 'temFoto' | 'fotoVersao' | 'slug'>;

export const meuPerfilPublicoService = {
  obter: async (): Promise<MeuPerfilPublico> => {
    const response = await api.get<MeuPerfilPublico>('/meu-perfil-publico');
    return response.data;
  },
  salvar: async (dados: MeuPerfilPublicoEdicao): Promise<MeuPerfilPublico> => {
    const response = await api.put<MeuPerfilPublico>('/meu-perfil-publico', dados);
    return response.data;
  },
  enviarFoto: async (arquivo: File): Promise<MeuPerfilPublico> => {
    const form = new FormData();
    form.append('file', arquivo);
    const response = await api.put<MeuPerfilPublico>('/meu-perfil-publico/foto', form);
    return response.data;
  },
  removerFoto: async (): Promise<MeuPerfilPublico> => {
    const response = await api.delete<MeuPerfilPublico>('/meu-perfil-publico/foto');
    return response.data;
  },
};
